import isEmptyTextNode from '../verifiers/is-empty-text-node';

const splitSiblings = (rootNode, liveNode, clonedNode) => {
  if (rootNode === liveNode) {
    return clonedNode;
  }

  const parentLiveNode = liveNode.parentNode;
  const clonedParentNode = liveNode.parentNode.cloneNode(false);

  if (clonedNode && !isEmptyTextNode(clonedNode)) {
    clonedParentNode.appendChild(clonedNode);
  }

  while (liveNode.previousSibling) {
    clonedParentNode.insertBefore(liveNode.previousSibling, clonedParentNode.firstChild);
  }

  if (parentLiveNode !== rootNode) {
    return splitSiblings(rootNode, parentLiveNode, clonedParentNode);
  }

  return clonedParentNode;
};

export default splitSiblings;
